import React from 'react'
import OutlinedButton from '../common/OutlinedButton'
import { Container, HStack, Text, Box, Image, } from '@chakra-ui/react'
import { MdOutlineClose } from "react-icons/md";
import { useWishList } from '../../providers/WishListProvider';
import { Link } from 'react-router-dom';

export default function Wishlist() {

    const { wishList, removeFromWishList } = useWishList();

    return (
        <Container
            minH='80vh'
            maxW='5xl'
            justifyContent={'space-between'}
            alignItems={'center'}
        >
            <Text
                py='12'
                as={'h1'}
                fontSize={'4xl'}
                w={'100%'}
                textAlign={'center'}
            >
                Wishlist
            </Text>

            {wishList.length === 0 && (
                <Text fontSize='xl' fontWeight={600} width='100%' textAlign='center'>No items in your wishlist</Text>
            )}

            {wishList.length > 0 && (
                <Box w='100%'>

                <HStack my='5' borderBottom='1px solid #1c1c1c'>
                    <Text fontSize={{base:'md', md:'xl'}} fontWeight={600} width='60%'>Product</Text>
                    <Text fontSize={{base:'md', md:'xl'}} fontWeight={600} width='12.5%'>Price</Text>
                    <Text fontSize={{base:'md', md:'xl'}} fontWeight={600} width='12.5%'>Stock</Text>
                    <Text fontSize={{base:'md', md:'xl'}} fontWeight={600} width='15%'>Action</Text>
                </HStack>


                {wishList.map((item, index) => {
                    return <HStack key={index} my='5'>
                        <HStack width='60%' gap={5} alignItems='center' justifyContent='start'>
                            <Image
                                src={item.product.product_variants.image1}
                                alt={item.product.products.name}
                                w={{base:'10', md:'20'}}
                            />
                            <Text
                                fontSize={{base:'sm', md:'lg'}}
                                color={'#000000'}
                                fontWeight={500}
                            >{item.product.products.name}
                            </Text>
                        </HStack>

                        <Text width='12.5%'>₹{item.product.product_variants.selling_price}</Text>

                        <Text width='12.5%' fontSize={{base:'xs', md:'lg'}}>{item.product.is_available_in_stock ? 'IN STOCK' : 'OUT OF STOCK'}</Text>

                        <HStack w='15%'>
                            <OutlinedButton
                                px='2'
                                as={Link}
                                to={`/product/${item.product.product_variants.slug}`}
                                fontSize={{base:'xs', md:'sm'}}
                            >
                                VIEW
                            </OutlinedButton>
                            <MdOutlineClose
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    removeFromWishList(item.product_id, item.product_variant_id);
                                }}
                            />
                        </HStack>

                    </HStack>
                    })}
                </Box>
            )}
        </Container>
    )
}